/* --------------------------------------------------------------------------------------
   log.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class logService {
  constructor (dataService) {
    this.dataService = dataService
  }
  log(errorMessage) {
    return this.dataService.postLog(errorMessage)
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/log.service.js